module.exports = __webpack_public_path__ + "956f4753c27f1a1aa6b61a50eeccf019.svg";